export const VIEW_FREIGHT_INVOICES_PERMISSION = 'invoicing.view_freight_invoices';
export const UPDATE_FREIGHT_INVOICES_PERMISSION = 'invoicing.update_freight_invoices';
export const CREATE_FREIGHT_INVOICES_PERMISSION = 'invoicing.create_freight_invoices';
export const SETTLEMENTS_ADMINISTRATOR_PERMISSION = 'settlements.admin';
export const VIEW_SETTLEMENTS_DASHBOARD_PERMISSION = 'settlements.view_dashboard';
